 import { InputComponent } from '../../core/Forms';
import * as UI from '../../common';
import React, { useState } from 'react';
import View from '../../../assets/icons/svgicons/View.svg';
import { Button, SidebarDrawer } from '../../common';
import ProcessSuccessful from '../../../assets/icons/ProcessSuccessful';
import { validateNewPasswordForm } from '../../../modules/settings/settings';
import toast from 'react-hot-toast';

interface NewPasswordProps {
  oldPassword: string;
onSubmit:(newPassword: string, confirmPassword: string) => void;
  onCancel: () => void;

}

export const NewPassword: React.FC<NewPasswordProps> = ({ onSubmit, onCancel, oldPassword}) => {
    const [currentPassword, setCurrentPassword] = useState<string>('');
  const [newPassword, setNewPassword] = useState<string>('');
   const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isLoading, setIsLoading] = React.useState(false);
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  
const handleNewPasswordSubmit = (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
  e?.preventDefault();
  
  const validationErrors = validateNewPasswordForm(newPassword, confirmPassword, oldPassword);

  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    toast.error('Please fix the errors in the form');
    return;
  }

  try {
    setIsLoading(true);
    onSubmit(newPassword, confirmPassword);

    setShowSuccessModal(true);
    setNewPassword('');
    setConfirmPassword('');
    setErrors({});
  } catch (error) {
  } finally {
    setIsLoading(false);
  }
};
  
  return (

    <div className='w-full flex justify-center mt-[-1.3em] lg:mt-[1em] md:mt-[1em]'>
      <div className="bg-[#FFFFFF] min-h-screen mx-[-60px] sm:mx-0  sm:w-full w-[350px]  lg:w-full lg:mt-[-1em] lg:ml-[-1em] lg:h-[70vh] ">
      <h1 className="text-[20px] lg:text-[20px] font-semibold pl-[20px] sm:pl-[24px] lg:font-semibold lg:pl-[64px] pt-[32px] lg:pt-[55px] ">Change Password</h1>
      <p className="text-[12px] lg:text-[13px] font-sm lg:font-sm pl-[20px] sm:pl-[24px]  lg:pl-[64px] lg:pt-[7px]">Secure your account with a strong password.</p>
      {/* <hr className='mt-[24px] lg:mt-[1em] lg:w-[555px]'/> */}
      <p className="text-[16px] ml-[-14em] md:ml-[2em] text-center lg:text-left lg:text-[16px] font-sm lg:font-sm pl-[20px] lg:pl-[64px] pt-[16px] lg:pt-[11px]">New Password</p>
      <form>
        <div className="flex flex-col md:flex w-full md:flex-col justify-center lg:justify-start items-center lg:items-end sm:ml-0 mt-[24px] lg:pr-[64px]">
          <div className=" ">
            <label htmlFor="Password" className="font-sm  text-[12px] lg:text-[13px] text-black ">
              Create Password
            </label>
            <InputComponent
              placeholder="Create Password"
              name="newPassword"
              type="password"
              value={newPassword}
              handleChange={(event: { target: { value: React.SetStateAction<string>; }; }) => setNewPassword(event.target.value)}
              className="w-[310px] sm:w-[434px] md:w-[434px] mt-[]  "
              error={errors.newPassword}
              imageClassName="xl:ml-[25em] xl:mt-[-5em] ml-[16em] mt-[-5em] md:ml-[25em]"
            />
          </div>
        </div>
        <div className="flex flex-col md:flex w-full md:flex-col justify-center lg:justify-start items-center lg:items-end sm:ml-0 mt-[24px] lg:pr-[64px]">
          <div className="">
            <label htmlFor="Password" className=" font-sm text-[13px] text-black ">
              Confirm Password
            </label>
            <InputComponent
              placeholder="Confirm Password"
              name="confirmPassword"
              type="password"
              image={View}
              value={confirmPassword}
              handleChange={(event: { target: { value: React.SetStateAction<string>; }; }) => setConfirmPassword(event.target.value)}
              className="w-[310px] sm:w-[434px] md:w-[434px] mt-[1em] "
              error={errors.comfirmPassword}
              imageClassName="xl:ml-[25em] xl:mt-[-5em] ml-[16em] mt-[-5em] md:ml-[25em]"
            />
          </div>
        </div>

        <div className="flex flex-col md:flex md:flex-col md:w-full md:justify-center items-center lg:justify-start lg:items-end  mt-[2em] bg-white text-[#044E97] lg:pr-[64px]">
          <div className="w-[310px] sm:w-[434px] md:w-[434px] ">
            <UI.Button
              text="Save Password"
             
              isLoading={isLoading} disabled={isLoading}
            onClick={(e) => handleNewPasswordSubmit(e)}

            />
          </div>
        </div>
        <div className=" flex flex-col md:flex md:flex-col md:w-full md:justify-center items-center lg:justify-start lg:items-end  mt-[2em] lg:pr-[64px] bg-white text-[#044E97]">
          <div className="w-[310px] sm:w-[434px] md:w-[434px]">
            <Button text="Cancel" isLoading={isLoading} disabled={isLoading} onClick={onCancel} outline/>
          </div>
        </div>
      </form>
      {showSuccessModal && (
        <>
          <SidebarDrawer
            title="Password Changed Successfully"
            show={true}
            onClose={() => false}
            position={'right'}
            children={<ProcessSuccessful />}
           ></SidebarDrawer>
    </>
      )}
    </div>
    </div>
    
  );
};
